import request from '@/assets/js/request';
import store from '@/store';

export default function userActionSave(data = {}) {
	let usersDataSave = {
		 ...data,
		 // activeId: null,  // 如果IsActiveAct为1，则该字段不可为空
		 // advert: null,  // 广告
		 // category: null,  // 分类
		 // content: null,  // 内容
		 // ctn: null,  // 商品数据
		 // isActiveAct: 0,  // 是否活动互动（0-否 1-是）
		 channelDetailsId: 4, // 飞利浦PC端渠道详情id
		 channelId: 1, // 渠道id,小程序3,内购:5,pc:1
		 userId: store.getters.info.uniqueId ? store.getters.info.uniqueId : null // 用户唯一id
	}
	request(`/data-backend/data/userAction/save`, 'POST', usersDataSave, false)
}



// WEBPACK FOOTER //
// ./src/plugins/userActionSave.js